import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/** Minimal shared nav + footer shell for dedicated public marketing pages
 * (ResumeCheckerPage, MarketplacePage, RecruiterLandingPage) — keeps them
 * visually consistent with the homepage without duplicating the full landing
 * nav's mobile menu/help-modal logic (those live only on "/"). */
export const PublicPageShell = ({ children }) => {
  return (
    <div className="min-h-screen bg-background text-white overflow-x-hidden">
      <nav className="fixed top-0 w-full z-50 bg-[#0A101D]/70 backdrop-blur-xl border-b border-white/10" data-testid="public-page-navbar">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="public-page-logo" className="flex items-center gap-2">
            <img src="/icons/cloudivo-mark.png" alt="Cloudivo" className="w-8 h-8 object-contain" />
            <span className="font-heading font-semibold">Cloudivo</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/" data-testid="public-page-back-home-link" className="hidden sm:flex items-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-white transition-colors">
              <ArrowLeft className="w-3.5 h-3.5" /> Back to Home
            </Link>
            <Link to="/login" data-testid="public-page-login-link" className="text-sm text-slate-300 hover:text-white px-4 py-2 transition-colors">Log In</Link>
            <Link to="/register" data-testid="public-page-get-started-btn" className="text-sm font-semibold bg-primary hover:bg-primary/90 px-4 py-2 rounded-lg transition-colors">Get Started</Link>
          </div>
        </div>
      </nav>

      <div className="pt-16">{children}</div>

      <footer className="border-t border-white/10 py-8 px-6 text-center" data-testid="public-page-footer">
        <div className="flex items-center justify-center gap-2 mb-3">
          <img src="/icons/cloudivo-mark.png" alt="Cloudivo" className="w-5 h-5 object-contain" />
          <span className="font-heading font-semibold text-sm text-white">Cloudivo</span>
        </div>
        <p className="text-xs text-slate-400">© 2026 Cloudivo · cloudivo.ai — Learn. Build. Get Hired.</p>
      </footer>
    </div>
  );
};
